import { createContext, useContext, useEffect, useState } from "react";

const UnitEditContext = createContext();
export function UnitEdit(props) {
    const { unit } = props;
    const [edit, setEdit] = useState(unit)

    useEffect(() => {
        if (unit !== edit) {
            setEdit(unit)
        }
    }, [unit])

    if (!unit) {
        return <></>
    }

    return <UnitEditContext.Provider
        value={{
            unit,
            edit,
            setEdit
        }}
        {...props}
    />
}

export function useUnitEdit() {
    const { edit, setEdit, unit } = useContext(UnitEditContext)
    const comp = edit.composition;

    function setField(field, value) {
        const edited = { ...edit }
        edited[field] = value;
        setEdit(edited)
    }

    function buildField(field) {
        return {
            onChange: e => setField(field, e.target.value),
            value: edit[field]
        }
    }

    function editComposition(data) {
        setEdit({ ...edit, composition: { ...edit.composition, ...data } })
    }

    function setCategory(cat, v) {
        if (!v) {
            const categories = edit.categories.filter(c => c !== cat)
            setEdit({ ...edit, categories })
        } else {
            const categories = [...edit.categories]
            categories.push(cat)
            setEdit({ ...edit, categories })
        }
    }

    return {
        unit: edit,
        hasModels: Boolean(edit.composition.models),
        useModels: (v) => editComposition({ models: v ? (unit.composition.models || []) : undefined }),

        field: buildField,

        hasCategory: (c) => edit.categories.includes(c.trim().toLowerCase()),
        setCategory,
        updateComposition: editComposition,
    }
}